const domUtils = {
    getBackgroundColor: function (element) {
        while (element) {
            let backgroundColor = window.getComputedStyle(element, null).getPropertyValue('background-color');
            if (backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
                return backgroundColor;
            }
            element = element.parentElement;
        }
        return null; // No background color found

    },
    setBackgroundColor: function (formElement, cssClass= null) {
        let selectorString = cssClass != null ? cssClass : 'label';
        let color = this.getBackgroundColor(formElement);
        let element = formElement.querySelector(selectorString);
        if (element && color) {
            element.style.backgroundColor = color;
        }
    }
};

export { domUtils as default };

